export default __webpack_public_path__ + "static/media/CLB_PrimaryLogo.0c7bc0d3.png";